import { WebPlugin } from '@capacitor/core';
export class BackgroundTaskWeb extends WebPlugin {
    beforeExit(_cb) {
        throw this.unimplemented('Not implemented on web.');
    }
    finish(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map